<div class="tw:flex tw:flex-col tw:justify-center">
    @if (history.length > 0) {
        <dv-simple-table
            [columns]="columns"
            [data]="history"
            [config]="tableConfig"
        ></dv-simple-table>
    } @else {
        <dv-warning [text]="'KEINE_VERLAUF_DATEN' | translate"></dv-warning>
    }
    <button
        (click)="navigateBack()"
        type="button"
        class="dv-btn tw:self-center cancel-button"
        translate
    >
        ZURUECK_ONLY
    </button>
</div>
